import { alpha, Box, Container, Link, List, ListItem, Paper, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import logo from "src/assets/images/logo/logo_blue_white.png";
import WalletButton from "src/components/button/WalletButton";
import Notification from "src/components/Notification";
import navigation, { rightNavConfig } from "src/configs/navigation";
import Sidebar from "./Sidebar";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    background: theme.palette.background.primary,
    zIndex: theme.zIndex.appBar,
    borderBottom: "1px solid #ffffff24",
  },
  boxContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center",
    margin: "auto",
    height: 59,
    padding: theme.spacing(0, 4),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.5, 2),
    },
  },
  navWrapper: {
    display: "flex",
    alignItems: "center",
  },
  navLink: {
    height: 59,
    padding: "8px 10px",
    margin: "0px 8px",
    color: alpha(theme.palette.common.white, 0.65),
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    fontSize: "1rem",
    cursor: "pointer",
    transition: "color 300ms linear",
    fontWeight: 400,
    lineHeight: 1,
    "&:hover": {
      color: theme.palette.common.white,
      textDecoration: "none",
    },
  },
  activeLink: {
    color: theme.palette.common.white,
    borderBottom: "3px solid",
    borderBottomColor: theme.palette.primary.main,
    paddingBottom: "5px",
  },
  dropdown: {
    position: "relative",
  },
  dropdownContent: {
    position: "absolute",
    top: "100%",
    right: 0,
    minWidth: "100%",
    zIndex: 100,
    visibility: "hidden",
    opacity: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  dropdownItem: {
    padding: theme.spacing(0.5, 1),
    "& $navLink": {
      height: "auto",
      color: theme.palette.text.primary,
      whiteSpace: "nowrap",
      width: "100%",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    "& $activeLink": {
      border: 0,
      color: theme.palette.primary.main,
    },
  },
}));

export default function Header() {
  const accountAddress = useSelector((state) => state.accountSlice.address);
  const isDarkMode = useSelector((state) => state.themeSlice.isDarkMode);
  const cls = useStyles({ accountAddress, isDarkMode });
  const small = useMediaQuery("(min-width:1070px)");
  const small1 = useMediaQuery("(min-width:1300px)");

  function onMenuMouseEnter(id) {
    const element = document.getElementById(`paper_${id}`);
    element.style.visibility = "visible";
    element.style.opacity = 1;
  }

  function onMenuMouseLeave(id) {
    const element = document.getElementById(`paper_${id}`);
    element.style.visibility = "hidden";
    element.style.opacity = 0;
  }

  function renderNav(navConfig) {
    const renderItem = (item) => {
      const AnchorTag = item.externalLink ? Link : NavLink;
      return (
        <AnchorTag
          key={item.id}
          className={cls.navLink}
          activeClassName={cls.activeLink}
          href={item.externalLink ? item.navLink : undefined}
          target={item.newTab ? "_blank" : undefined}
          to={item.externalLink ? undefined : item.navLink}
        >
          {item.icon}
          <Box px={0.2} />
          {item.title}
        </AnchorTag>
      );
    };

    return navConfig.map((item) => {
      return item.children ? (
        <div
          key={item.id}
          className={clsx(cls.navLink, cls.dropdown)}
          onMouseEnter={() => onMenuMouseEnter(item.id)}
          onMouseLeave={() => onMenuMouseLeave(item.id)}
        >
          {item.icon}
          <Box px={0.2} />
          <Box lineHeight={1}>{item.title}</Box>
          <ExpandMoreOutlinedIcon fontSize="small" />
          <Paper elevation={0} className={clsx(cls.dropdownContent)} id={`paper_${item.id}`}>
            <List component="ul">
              {item.children.map((cItem) => (
                <ListItem key={cItem.id} button className={cls.dropdownItem}>
                  {renderItem(cItem)}
                </ListItem>
              ))}
            </List>
          </Paper>
        </div>
      ) : (
        renderItem(item)
      );
    });
  }

  return (
    <Box className={cls.root}>
      <Container maxWidth="xl" className={cls.boxContainer}>
        <Box className={cls.navWrapper}>
          <a href="https://nft.trava.finance">
            <img src={logo} alt="Logo" style={{ height: "36px", verticalAlign: "middle" }} />
          </a>
          {small && (
            <Box px={4} height="100%" display="flex">
              {renderNav(navigation)}
            </Box>
          )}
        </Box>
        <Box display="flex" alignItems="center" height="100%">
          <Notification />
          {small1 && <Box height="100%">{renderNav(rightNavConfig)}</Box>}
          <WalletButton />
          {!small && <Sidebar />}
        </Box>
      </Container>
    </Box>
  );
}
